module.exports = require("date-fns/isPast");